import React, { useEffect, useState, useRef, useCallback  } from 'react';
import { collection, addDoc } from "firebase/firestore";
import { db } from './firebase'; // firebase.js 경로에 맞게 수정하세요.

// 네이버 지도 컴포넌트 (기존 코드)
function DescriptionBox({ children }) {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const boxWidth = windowWidth < 768 ? '80%' : '350px';

  return (
    <div
      style={{
        width: boxWidth,
        margin: '20px auto',
        padding: '15px',
        border: '1px solid #ccc',
        borderRadius: '8px',
        backgroundColor: '#f9f9f9',
        textAlign: 'center',
      }}
    >
      <p style={{ margin: '5px 0' }}>전화번호: 1577-8788</p>
      <p style={{ margin: '5px 0' }}>영업시간: 10:00 ~ 17:00 </p>
      

    </div>
  );
}

// 상담신청 폼 컴포넌트 (기존 코드 그대로)
function ConsultationForm() {
  const [name, setName] = useState('');
  const [contact, setContact] = useState('');
  const [interest, setInterest] = useState('');
  const [content, setContent] = useState('');
  const [agreePersonal, setAgreePersonal] = useState(false);
  const [agreeThirdParty, setAgreeThirdParty] = useState(false);
  const [agreeMarketing, setAgreeMarketing] = useState(false);
  const [agreeAll, setAgreeAll] = useState(false);

  useEffect(() => {
    if (agreeAll) {
      setAgreePersonal(true);
      setAgreeThirdParty(true);
      setAgreeMarketing(true);
    }
  }, [agreeAll]);

  useEffect(() => {
    if (!agreePersonal || !agreeThirdParty || !agreeMarketing) {
      setAgreeAll(false);
    }
  }, [agreePersonal, agreeThirdParty, agreeMarketing]);

  const isFormValid =
    name.trim() !== '' &&
    contact.trim() !== '' &&
    interest !== '' &&
    content.trim() !== '' &&
    agreePersonal;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isFormValid) return;

    // 폼 데이터 구성
    const formData = {
      name,
      contact,
      interest,
      content,
      agreePersonal,
      agreeThirdParty,
      agreeMarketing,
      createdAt: new Date(),
    };

    try {
      // "consultations" 컬렉션에 데이터 저장
      const docRef = await addDoc(collection(db, "Counsel"), formData);
      console.log("Document written with ID: ", docRef.id);
      alert('상담신청이 완료되었습니다!');
    } catch (error) {
      console.error("Error adding document: ", error);
      alert("상담 신청에 실패했습니다. 다시 시도해주세요.");
    }

    // 폼 리셋
    setName('');
    setContact('');
    setInterest('');
    setContent('');
    setAgreePersonal(false);
    setAgreeThirdParty(false);
    setAgreeMarketing(false);
    setAgreeAll(false);
  };

  return (
    <form onSubmit={handleSubmit} style={{ maxWidth: '600px', margin: '40px auto', marginBottom: '120px', padding: '20px',  boxSizing: 'border-box' }}>
      <h2 style={{ textAlign: 'center' }}>▣ 상담신청 ▣</h2>

      {/* 이름 입력 */}
      <div style={{ marginBottom: '10px', borderBottom: '1px solid #ccc', paddingBottom: '5px' }}>
        <label style={{ display: 'block', marginBottom: '0px', left: '-10px' }}><strong>이름</strong></label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          style={{ width: '100%', padding: '8px', marginTop: '0px', border: 'none', outline: 'none' }}
        />
      </div>

      {/* 연락처 입력 */}
      <div style={{ marginBottom: '10px', borderBottom: '1px solid #ccc', paddingBottom: '5px' }}>
        <label style={{ display: 'block', marginBottom: '0px', left: '-10px' }}><strong>연락처</strong></label>
        <input
          type="text"
          value={contact}
          onChange={(e) => setContact(e.target.value)}
          style={{ width: '100%', padding: '8px', marginTop: '0px', border: 'none', outline: 'none' }}
        />
      </div>

      {/* 관심분야 라디오 버튼 */}
      <div style={{ marginBottom: '10px', borderBottom: '1px solid #ccc', paddingBottom: '5px' }}>
        <p style={{ marginBottom: '5px', left: '-10px' }}><strong>관심분야</strong>:</p>
        <label style={{ marginRight: '15px' }}>
          <input
            type="radio"
            name="interest"
            value="신규"
            checked={interest === '신규'}
            onChange={(e) => setInterest(e.target.value)}
          />
          신규
        </label>
        <label style={{ marginRight: '15px' }}>
          <input
            type="radio"
            name="interest"
            value="분양"
            checked={interest === '분양'}
            onChange={(e) => setInterest(e.target.value)}
          />
          분양
        </label>
        <label>
          <input
            type="radio"
            name="interest"
            value="이장"
            checked={interest === '이장'}
            onChange={(e) => setInterest(e.target.value)}
          />
          이장
        </label>
      </div>

      {/* 상담내용 입력 */}
      <div style={{ marginBottom: '10px', borderBottom: '1px solid #ccc', paddingBottom: '5px' }}>
        <label style={{ display: 'block', marginBottom: '0px', left: '-10px' }}><strong>상담내용</strong>:</label>
        <textarea
          value={content}
          onChange={(e) => setContent(e.target.value)}
          style={{ width: '100%', padding: '8px', marginTop: '0px', height: '100px', border: 'none', outline: 'none' }}
        />
      </div>

      {/* 동의 항목 */}
      <div style={{ marginBottom: '10px', borderBottom: '1px solid #ccc', paddingBottom: '5px' }}>
        <h3 style={{ marginBottom: '5px', left: '-10px' }}>동의 항목</h3>
        <label style={{ display: 'block', marginBottom: '5px' }}>
          <input
            type="checkbox"
            checked={agreeAll}
            onChange={(e) => setAgreeAll(e.target.checked)}
          />
          <strong> 전체동의 (누르면 모두 체크)</strong>
        </label>
        <label style={{ display: 'block', marginLeft: '20px', marginBottom: '5px' }}>
          <input
            type="checkbox"
            checked={agreePersonal}
            onChange={(e) => setAgreePersonal(e.target.checked)}
          />
          개인정보 수집 및 이용에 관한 동의 (필수)
        </label>
        <label style={{ display: 'block', marginLeft: '20px', marginBottom: '5px' }}>
          <input
            type="checkbox"
            checked={agreeMarketing}
            onChange={(e) => setAgreeMarketing(e.target.checked)}
          />
          마케팅 활용에 관한 동의 (선택)
        </label>
      </div>
      {/* 전송 버튼 */}
      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <button 
          type="submit" 
          disabled={!isFormValid}
          style={{ padding: '10px 20px', cursor: isFormValid ? 'pointer' : 'not-allowed',
            backgroundColor: isFormValid ? '#D4AF37' : '#ccc', // 활성화: 금색, 비활성화: 회색
            color: isFormValid ? '#ffffff' : '#666',  }}
        >
          
          전송
        </button>
      </div>
    </form>
  );
}


// SideNav 컴포넌트: 화면 옆에 고정된 네비게이션 링크와 스크롤 인디케이터
function SideNav({ activeSection }) {
  const contactRef = useRef(null);
  const consultationRef = useRef(null);
  const [indicatorStyle, setIndicatorStyle] = useState({ top: 0, height: 0 });

  // activeSection에 따라 해당 링크의 offsetTop과 offsetHeight를 이용해 인디케이터 위치/높이 업데이트
  const updateIndicator = useCallback(() => {
    let ref = null;
    if (activeSection === 'contact') {
      ref = contactRef.current;
    } else if (activeSection === 'consultation') {
      ref = consultationRef.current;
    }
    if (ref) {
      setIndicatorStyle({
        top: ref.offsetTop,
        height: ref.offsetHeight,
      });
    }
  }, [activeSection]);

  useEffect(() => {
    updateIndicator();
  }, [updateIndicator]);

  // 스크롤 시에도 업데이트
  useEffect(() => {
    window.addEventListener('scroll', updateIndicator);
    return () => window.removeEventListener('scroll', updateIndicator);
  }, [updateIndicator]);

  return (
    <div className="side-nav">
      <div className="nav-indicator" style={indicatorStyle}></div>
      <a
        ref={contactRef}
        href="#contact"
        className={`nav-link ${activeSection === 'contact' ? 'active' : ''}`}
      >
        상담신청
      </a>
      <a
        ref={consultationRef}
        href="#consultation"
        className={`nav-link ${activeSection === 'consultation' ? 'active' : ''}`}
      >
        고객문의
      </a>
 
    </div>
  );
}



// Contact 페이지: 지도, 상담 폼과 함께 SideNav 표시 (PC 전용)
function Contact() {
  const [activeSection, setActiveSection] = useState('');

  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
  }, []);

  useEffect(() => {
    const sections = document.querySelectorAll('section');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      { threshold: 0.5 }
    );
    sections.forEach(section => observer.observe(section));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="page">
      <SideNav activeSection={activeSection} />
      <div className="spacer-medium"></div>
      <section id="contact">
        <ConsultationForm />
      </section>
      <div className="spacer-medium"></div>
      <section id="consultation">
      <h2 style={{ textAlign: 'center' }}>▣ 고객문의 ▣</h2>
      <DescriptionBox>
      </DescriptionBox>
      <div className="spacer-medium"></div>
      </section>
    

    </div>
  );
}

export default Contact;
